import React, { Component } from 'react';
import { Dropdown } from 'semantic-ui-react';

class DropdownNavBar extends Component {
  render() {
    return (
      <div>

            <Dropdown text={this.props.user}>
            <Dropdown.Menu>
                    <Dropdown.Item text='Edit Profile'  />
                    <Dropdown.Item text='Logout' onClick={this.props.onLogout}/>
            </Dropdown.Menu>
            </Dropdown>
        
      </div>
    )
  }
}

export default DropdownNavBar;



// WEBPACK FOOTER //
// ./src/HomeComponents/HeaderComponents/DropdownNavBar.js